<p-toast [preventDuplicates]="true" [preventOpenDuplicates]="true"/>
<p-divider/>
<div class="" *ngFor="let prj of tramiteService.proyectoAsignado()">
    <div class="card h-full">
        <div class="flex flex-column md:flex-row justify-content-between align-items-center mb-4">
            <div class="flex flex-column text-center md:text-left">
                <span class="text-700 text-2xl mb-2 font-bold">Proyecto: {{ tramiteService.proyectoAsignado()[0].nombre }}</span>
                <span class="text-700 text-lg">{{ tramiteService.proyectoAsignado()[0].descripcion }}</span>
            </div>
            <div class="p-toolbar-group-end">
                        <span class="p-2">
                               <p-button
                                   (click)="goBack()"
                                   label="Regresar"
                                   icon="pi pi-undo text-2xl"
                                   styleClass="p-button-rounded ml-2"/>
                        </span>
            </div>
        </div>
        <p-tabView>
            <p-tabPanel>
                <ng-template pTemplate="header">
                    <i class="pi pi-book"></i>
                    <span class="pl-1">Generales</span>
                </ng-template>
                <app-generales-proyecto [rendertitle]="true" [prj]="prj"
                ></app-generales-proyecto>
            </p-tabPanel>
        </p-tabView>
    </div>
</div>
<p-divider/>
<shared-loader class="global-overlay" [hidden]="!_showLoader"></shared-loader>
<p-card *ngIf="this.selected!==null"
        [header]="esConstruccion()!=null?!esConstruccion()?this.selected.nombreTramite + ' - URBANIZACION':this.selected.nombreTramite:''">
<!--    Dialog profesionales-->
    <p-messages severity="error">
        <ng-template pTemplate>
            <div class="ml-2">Favor tomar en cuenta que después de realizar el pago del trámite y/o completar el trámite, no podrá modificar las áreas</div>
        </ng-template>
    </p-messages>
    <p-dialog header="Búsqueda de profesionales" [(visible)]="showProfesionales" [modal]="true"
              [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
              [style]="{ width: '50vw'}" [draggable]="false" [resizable]="false" (onHide)="cerrarDialog()"
              (keydown)="onKeyDown($event)">
        <div class="field">
            <div class="field col-12 md:col-3">
                <label class="text-900 font-semibold">Tipo profesional</label>
                <p-dropdown [(ngModel)]="profesionalSeleccionado" #nivelDrop [options]="profesionales"
                            optionLabel="descripcion" [showClear]="true" placeholder="Seleccione tipo de profesional *"
                            [required]="true"></p-dropdown>
                <small style="color:red" class="ng-dirty ng-invalid" *ngIf="!profesionalSeleccionado">
                    <b>Favor seleccionar tipo de profesional</b>
                </small>
            </div>
            <div class="field col-12 -mt-3">
                <shared-consulta-usuario [typeFilter]="2" [typeActionTo]="TipoAutorizaciones.Profesional"></shared-consulta-usuario>
            </div>
            <div class="field col-12 md:col-4">
                <p-button class="ml-3" icon="pi pi-plus" pTooltip="Agregar profesional"
                          (onClick)="agregarProfesionales()" [disabled]="!botonAgregarProfesional"></p-button>
            </div>
        </div>
    </p-dialog>
    <div *ngIf="esConstruccion()!=null">
        <p-panel [collapsed]="false" [header]="!esConstruccion()?'Detalles de lotes':'Detalles de Construcción'"
                 [toggleable]="true">

                <app-areas-form
                    *ngIf="esFormularioActivo('formb')"
                    [tipo]="'formb'"
                    [areaActiva]="areaActiva"
                    [setAreaActiva]="setAreaActiva.bind(this)"
                    [tramiteCompleto]="tramiteCompleto"
                    [readOnly]="isReadOnly()"
                    [tipoConstruccion]="esConstruccion"
                    (onBlurFb)="onChangeArea($event, areaActiva()!)">
                </app-areas-form>
            <ng-container *ngIf="!esConstruccion(); else elseTemplate">
                <div class="text-900 font-semibold text-xl">Lotes</div>
                <div class="p-fluid p-formgrid grid mt-2">
                    <div class="field col-12 md:col-3">
                        <p-inputNumber placeholder="Cantidad de lotes" [(ngModel)]="cantidadLotes"
                                       id="withoutgrouping" [required]="true" [useGrouping]="false"
                                       pTooltip="Ingresar cantidad"
                                       [ngClass]="{'ng-invalid ng-dirty' : !tramiteCompleto && !cantidadLotes}"
                                       [min]="1"></p-inputNumber>
                    </div>
                    <div class="field col-12 md:col-3">
                        <p-dropdown [(ngModel)]="tipoLoteSeleccionado" #nivelDrop [options]="tipoLotes"
                                    optionLabel="descripcion" [showClear]="true" placeholder="Seleccione tipo lote *"
                                    [required]="true"
                                    [ngClass]="{'ng-invalid ng-dirty' : !tramiteCompleto && !tipoLoteSeleccionado}"></p-dropdown>
                    </div>
                    <div class="field col-12 md:col-3">
                        <p-button class="ml-3" icon="pi pi-plus" pTooltip="Agregar lote"
                                  (onClick)="agregarLotes()"></p-button>
                    </div>
                </div>
                <div>
                    <div class="text-900 font-semibold text-lg -mt-5 mb-5">
                        <small style="color:red" class="ng-dirty ng-invalid" *ngIf="errorLotes"><b>Favor ingresar una
                            cantidad de lote correcta y seleccionar el tipo de lote</b>
                        </small>
                    </div>
                    <p-table
                        #dtLotes [style]="{'border': camposCompletos && datosLotes.length==0?'1px solid red':''}"
                             columnResizeMode="expand" [value]="datosLotes" [paginator]="true"
                             styleClass="p-datatable-gridlines" [rows]="5" [showCurrentPageReport]="true"
                             [tableStyle]="{ 'min-width': '50rem' }"
                             currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} lotes del proyecto"
                             [rowsPerPageOptions]="[5, 10, 25, 50]">
                        <ng-template pTemplate="header">
                            <tr>
                                <th style="width:25%">Cantidad</th>
                                <th style="width:25%">Tipo</th>
                                <th style="width:25%">Operación</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-lotes let-index="rowIndex">
                            <tr>
                                <td>
                                    {{ lotes.cantidadLotes }}
                                </td>
                                <td>
                                    {{ lotes.descripcion }}
                                </td>
                                <td>
                                    <p-button pTooltip="Eliminar lote" icon="pi pi-trash"
                                              styleClass="p-button-rounded p-button-danger p-button-text"
                                              (click)="eliminarLote(index,lotes)"></p-button>
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                    <small style="color:red" class="ng-dirty ng-invalid"
                           *ngIf="!tramiteCompleto && datosLotes.length==0"><b>Favor ingresar uno o más lotes </b>
                    </small>
                </div>
            </ng-container>
            <ng-template #elseTemplate>
                <div class="text-900 font-semibold text-xl">Tipo inmueble</div>
                <div class="p-fluid p-formgrid grid mt-2">
                    <div class="field col-12 md:col-3">
                        <p-dropdown [(ngModel)]="tipoInmuebleSeleccionado" #nivelDrop [options]="tipoInmueble"
                                    optionLabel="descripcion" [showClear]="true"
                                    placeholder="Seleccione tipo inmueble *"
                                    [required]="!formCompletado() ? true : false"
                                    [ngClass]="{'ng-invalid ng-dirty' : !tramiteCompleto && !tipoInmuebleSeleccionado}"></p-dropdown>
                        <small style="color:red" class="ng-dirty ng-invalid"
                               *ngIf="!tramiteCompleto && !tipoInmuebleSeleccionado && !this.formCompletado()">
                            <b>Favor seleccionar un tipo de inmueble</b>
                        </small>
                    </div>
                </div>
                <div class="p-fluid p-formgrid grid mt-2" *ngIf="tipoInmuebleSeleccionado!=null">
                    <div class="field col-12 md:col-3" *ngIf="tipoInmuebleSeleccionado.id!='1'">
                        <span class="p-float-label">
                            <input id="tipoInmuebleText" type="text" [(ngModel)]="tipoInmuebleInput" #nombreInput
                                   required pInputText
                                   pTooltip="Ingresar inmueble"
                                   [ngClass]="{'ng-invalid ng-dirty' : !tramiteCompleto && !tipoInmuebleInput}"
                                   (keydown)="isCharactersValid($event)"/>
                            <label for="tipoInmuebleText"
                                   class="mb-2">{{ tipoInmuebleSeleccionado.id == '2' ? 'Tipo casa' : tipoInmuebleSeleccionado.id == '3' ? 'Tipo torre' : '' }}
                                <small style="color:red"><b>*</b></small></label>
                        </span>
                        <small style="color:red" class="ng-dirty ng-invalid" *ngIf="errorTipoInmubleInput"><b>Favor
                            ingresar tipo de inmueble</b>
                        </small>
                    </div>
                    <div class="field col-12 md:col-3">
                        <p-dropdown [(ngModel)]="nivelSeleccionado" #nivelDrop [options]="niveles"
                                    optionLabel="descripcion" [showClear]="true" placeholder="Seleccione el nivel *"
                                    [required]="true"
                                    [ngClass]="{'ng-invalid ng-dirty' : !tramiteCompleto && !nivelSeleccionado}"></p-dropdown>
                        <small style="color:red" class="ng-dirty ng-invalid" *ngIf="errorNiveles"><b>Favor seleccionar
                            un
                            nivel correcto</b>
                        </small>

                    </div>
                    <div class="field col-12 md:col-3">
                        <p-inputNumber
                            [placeholder]="tipoInmuebleSeleccionado.id=='1'?'Cantidad de locales':tipoInmuebleSeleccionado.id=='2'?'Cantidad de casas':tipoInmuebleSeleccionado.id=='3'?'Cantidad de apartamentos':''"
                            [(ngModel)]="cantidadUnidades" id="cantidadUnidades" mode="decimal" [required]="true"
                            [useGrouping]="false"
                            pTooltip="Ingresar cantidad"
                            [ngClass]="{'ng-invalid ng-dirty' : !tramiteCompleto && !cantidadUnidades}"
                            (keydown)="isNumericValid($event)">
                        </p-inputNumber>
                        <small style="color:red" class="ng-dirty ng-invalid" *ngIf="errorCantidad"><b>Favor ingresar una
                            cantidad correcta</b>
                        </small>
                    </div>
                    <div class="field col-12 md:col-3">
                        <p-button class="ml-3" icon="pi pi-plus"
                                  [pTooltip]="tipoInmuebleSeleccionado.id=='1'?'Agregar local':tipoInmuebleSeleccionado.id=='2'?'Agregar casa':tipoInmuebleSeleccionado.id=='3'?'Agregar apartamento':''"
                                  (onClick)="agregarDetConstruccion()"></p-button>
                    </div>
                    <div class="field col-12">
                        <p-table
                            #dtDetalleConstruccion [style]="{'border': camposCompletos && datosDetallesConstruccion.length==0?'1px solid red':''}"
                            columnResizeMode="expand" [value]="datosDetallesConstruccion" [paginator]="true"
                            styleClass="p-datatable-gridlines" [rows]="5" [showCurrentPageReport]="true"
                            [tableStyle]="{ 'min-width': '50rem' }"
                            currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} unidades habitacionales"
                            [rowsPerPageOptions]="[5, 10, 25, 50]">
                            <ng-template pTemplate="header">
                                <tr *ngIf="tipoInmuebleSeleccionado?.id?tipoInmuebleSeleccionado?.id=='1':false">
                                    <th style="width:25%">Nivel</th>
                                    <th style="width:25%">Cantidad</th>
                                    <th style="width:25%">Operación</th>
                                </tr>
                                <tr *ngIf="tipoInmuebleSeleccionado?.id?tipoInmuebleSeleccionado?.id=='2':false">
                                    <th style="width:25%">Tipo</th>
                                    <th style="width:25%">Nivel</th>
                                    <th style="width:25%">Cantidad</th>
                                    <th style="width:25%">Operación</th>
                                </tr>
                                <tr *ngIf="tipoInmuebleSeleccionado?.id?tipoInmuebleSeleccionado?.id=='3':false">
                                    <th style="width:25%">Torre</th>
                                    <th style="width:25%">Nivel</th>
                                    <th style="width:25%">Apartamentos</th>
                                    <th style="width:25%">Operación</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-niveles let-index="rowIndex">
                                <tr>
                                    <td *ngIf="tipoInmuebleSeleccionado?.id=='2' || tipoInmuebleSeleccionado?.id=='3'">
                                        {{ niveles.descripcion }}
                                    </td>
                                    <td>
                                        {{ niveles.idNivel }}
                                    </td>
                                    <td>
                                        {{ niveles.cantidad }}
                                    </td>
                                    <td>
                                        <p-button pTooltip="Eliminar nivel" icon="pi pi-trash"
                                                  styleClass="p-button-rounded p-button-danger p-button-text"
                                                  (click)="eliminarDetConstruccion(index)"></p-button>
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>
                        <small style="color:red" class="ng-dirty ng-invalid"
                               *ngIf="!tramiteCompleto && datosDetallesConstruccion.length==0">
                            <b>Favor ingresar uno o más detalles construcción</b>
                        </small>
                    </div>
                </div>

                <div class="text-900 font-semibold text-xl">Profesionales</div>
                <div class="p-fluid p-formgrid grid mt-2">
                    <div>
                        <p-button class="ml-3" icon="pi pi-user-plus" (onClick)="showProfesionales = !showProfesionales"
                                  label="Agregar profesional"></p-button>
                    </div>
                </div>
                <div class="p-fluid p-formgrid grid mt-2">
                    <div class="field col-12">
                        <p-table
                            #dtProfesionales [style]="{'border': camposCompletos && datosProfesionales.length==0?'1px solid red':''}"
                            columnResizeMode="expand" [value]="datosProfesionales" [paginator]="true"
                            styleClass="p-datatable-gridlines" [rows]="5" [showCurrentPageReport]="true"
                            [tableStyle]="{ 'min-width': '50rem' }"
                            currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} profesionales del proyecto"
                            [rowsPerPageOptions]="[5, 10, 25, 50]">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th style="width:25%">Responsable de diseño</th>
                                    <th style="width:25%">Número de registro</th>
                                    <th style="width:25%">Nombre</th>
                                    <th style="width:25%">Operaciones</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-profesionales let-index="rowIndex">
                                <tr>
                                    <td>
                                        {{ profesionales.responsableDescripcion }}
                                    </td>
                                    <td>
                                        {{ profesionales.numero_documento }}
                                    </td>
                                    <td>
                                        {{ profesionales.nombre }}
                                    </td>
                                    <td>
                                        <p-button pTooltip="Eliminar profesional" icon="pi pi-trash"
                                                  styleClass="p-button-rounded p-button-danger p-button-text"
                                                  (click)="eliminarProfesional(index)"></p-button>
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>
                        <small style="color:red" class="ng-dirty ng-invalid"
                               *ngIf="!tramiteCompleto && datosProfesionales.length==0 && !this.formCompletado()"><b>Favor ingresar uno o más
                            profesionales </b>
                        </small>
                    </div>
                </div>
            </ng-template>
        </p-panel>
        <div class="mt-5">
            <p-accordion [activeIndex]="0">
                <p-accordionTab header="Documentos y formularios" class="line-height-3 m-0">
                    <solicitud-requisitos [requisitos]="tramiteService.requisitosFormularios()"
                                          [idProyecto]="this.idProyecto"
                                          [idSolicitud]="this.selected!.idSolicitud?.toString()!"
                                          [idTramite]="this.idTramite"
                                          [datosCargados]="tramiteService.datosCargados"
                                          (onEventEmitterSelected)="onReceiveTramite($event)"
                    ></solicitud-requisitos>
                </p-accordionTab>
            </p-accordion>
        </div>
        <p-divider/>
        <p-panel [collapsed]="true" [header]="esConstruccion()?'Tramite Previos':''"
                 [toggleable]="true" *ngIf="esConstruccion() && !condicion;">
            <ng-container *ngIf="esConstruccion() && !condicion;">
                <app-tramites-previos *ngIf="!condicion" [pivoteTramitesPrevios]="1"></app-tramites-previos>
            </ng-container>
        </p-panel>

    </div>

    <div class="p-fluid p-formgrid grid mt-2">
        <div class="field col-12 md:col-9">
            <ul class="list-none m-0 w-full">
                <li class="flex justify-content-between surface-border py-3">
                    <span class="text-900 text-4xl font-medium">Total a cancelar por trámite: $ <b>{{ tarifa }}</b>
                    </span>
                </li>
            </ul>
        </div>
        <div class="field col-12 md:col-3">
            <div class="flex justify-content-end gap-2">
                    <p-button styleClass="p-button-icon p-button-info p-button-lg p-button-rounded w-full h-full" icon="pi pi-calculator" (onClick)="onChangeCalcularTarifa()"
                            pTooltip="Calcular tarifa" tooltipPosition="top"></p-button>
                    <p-button (onClick)="completarTramite()" label="Proceder a pagar"
                            icon="pi pi pi-cart-plus"
                            iconPos="right"
                            [rounded]="true"
                            styleClass="p-button-icon p-button-info text-xl h-full"
                            [disabled]="validacionBotonCompletarTramite() || isLoading()"></p-button>
            </div>
        </div>

    </div>
    <div class="p-fluid grid" *ngIf="tramiteService.textTarifa!=''">
        <div class="col-12 align-self-center">
            <small class="text-gray-600">*{{ tramiteService.textTarifa }}</small>
        </div>
    </div>
</p-card>
